(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (factory((global.PpAmountField = {}),global.React));
}(this, (function (exports,React) { 'use strict';

  var React__default = 'default' in React ? React['default'] : React;

  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };
    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  /* global define */

  (function () {

  	var hasOwn = {}.hasOwnProperty;

  	function classNames() {
  		var classes = [];

  		for (var i = 0; i < arguments.length; i++) {
  			var arg = arguments[i];
  			if (!arg) continue;

  			var argType = typeof arg;

  			if (argType === 'string' || argType === 'number') {
  				classes.push(arg);
  			} else if (Array.isArray(arg)) {
  				if (arg.length) {
  					var inner = classNames.apply(null, arg);
  					if (inner) {
  						classes.push(inner);
  					}
  				}
  			} else if (argType === 'object') {
  				if (arg.toString === Object.prototype.toString) {
  					for (var key in arg) {
  						if (hasOwn.call(arg, key) && arg[key]) {
  							classes.push(key);
  						}
  					}
  				} else {
  					classes.push(arg.toString());
  				}
  			}
  		}

  		return classes.join(' ');
  	}

  	if (module.exports) {
  		classNames.default = classNames;
  		module.exports = classNames;
  	} else {
  		window.classNames = classNames;
  	}
  }());
  });

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  var _freeGlobal = freeGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = _freeGlobal || freeSelf || Function('return this')();

  var _root = root;

  /** Built-in value references. */
  var Symbol$1 = _root.Symbol;

  var _Symbol = Symbol$1;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Built-in value references. */
  var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
    } catch (e) {}

    var result = nativeObjectToString.call(value);
    {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }

  var _getRawTag = getRawTag;

  /** Used for built-in method references. */
  var objectProto$1 = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString$1 = objectProto$1.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString$1.call(value);
  }

  var _objectToString = objectToString;

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag$1 && symToStringTag$1 in Object(value))
      ? _getRawTag(value)
      : _objectToString(value);
  }

  var _baseGetTag = baseGetTag;

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }

  var isObjectLike_1 = isObjectLike;

  /** `Object#toString` result references. */
  var numberTag = '[object Number]';

  /**
   * Checks if `value` is classified as a `Number` primitive or object.
   *
   * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
   * classified as numbers, use the `_.isFinite` method.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a number, else `false`.
   * @example
   *
   * _.isNumber(3);
   * // => true
   *
   * _.isNumber(Number.MIN_VALUE);
   * // => true
   *
   * _.isNumber(Infinity);
   * // => true
   *
   * _.isNumber('3');
   * // => false
   */
  function isNumber(value) {
    return typeof value == 'number' ||
      (isObjectLike_1(value) && _baseGetTag(value) == numberTag);
  }

  var isNumber_1 = isNumber;

  /**
   * Checks if `value` is `NaN`.
   *
   * **Note:** This method is based on
   * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
   * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
   * `undefined` and other non-number values.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   * @example
   *
   * _.isNaN(NaN);
   * // => true
   *
   * _.isNaN(new Number(NaN));
   * // => true
   *
   * isNaN(undefined);
   * // => true
   *
   * _.isNaN(undefined);
   * // => false
   */
  function isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return isNumber_1(value) && value != +value;
  }

  var _isNaN = isNaN;

  var fontfaceobserver_standalone = createCommonjsModule(function (module) {
  /* Font Face Observer v2.3.0 - © Bram Stein. License: BSD-3-Clause */(function(){function p(a,c){document.addEventListener?a.addEventListener("scroll",c,!1):a.attachEvent("scroll",c);}function u(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function b(){document.removeEventListener("DOMContentLoaded",b);a();}):document.attachEvent("onreadystatechange",function g(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",g),a();});}function w(a){this.g=document.createElement("div");this.g.setAttribute("aria-hidden","true");this.g.appendChild(document.createTextNode(a));this.h=document.createElement("span");this.i=document.createElement("span");this.m=document.createElement("span");this.j=document.createElement("span");this.l=-1;this.h.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.i.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
  this.j.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.m.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.h.appendChild(this.m);this.i.appendChild(this.j);this.g.appendChild(this.h);this.g.appendChild(this.i);}
  function x(a,c){a.g.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+c+";";}function B(a){var c=a.g.offsetWidth,b=c+100;a.j.style.width=b+"px";a.i.scrollLeft=b;a.h.scrollLeft=a.h.scrollWidth+100;return a.l!==c?(a.l=c,!0):!1}function C(a,c){function b(){var e=g;B(e)&&null!==e.g.parentNode&&c(e.l);}var g=a;p(a.h,b);p(a.i,b);B(a);}function D(a,c,b){c=c||{};b=b||window;this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal";this.context=b;}var E=null,F=null,G=null,H=null;function I(a){null===F&&(M(a)&&/Apple/.test(window.navigator.vendor)?(a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent),F=!!a&&603>parseInt(a[1],10)):F=!1);return F}function M(a){null===H&&(H=!!a.document.fonts);return H}
  function N(a,c){var b=a.style,g=a.weight;if(null===G){var e=document.createElement("div");try{e.style.font="condensed 100px sans-serif";}catch(q){}G=""!==e.style.font;}return [b,g,G?a.stretch:"","100px",c].join(" ")}
  D.prototype.load=function(a,c){var b=this,g=a||"BESbswy",e=0,q=c||3E3,J=(new Date).getTime();return new Promise(function(K,L){if(M(b.context)&&!I(b.context)){var O=new Promise(function(r,t){function h(){(new Date).getTime()-J>=q?t(Error(""+q+"ms timeout exceeded")):b.context.document.fonts.load(N(b,'"'+b.family+'"'),g).then(function(n){1<=n.length?r():setTimeout(h,25);},t);}h();}),P=new Promise(function(r,t){e=setTimeout(function(){t(Error(""+q+"ms timeout exceeded"));},q);});Promise.race([P,O]).then(function(){clearTimeout(e);
  K(b);},L);}else u(function(){function r(){var d;if(d=-1!=k&&-1!=l||-1!=k&&-1!=m||-1!=l&&-1!=m)(d=k!=l&&k!=m&&l!=m)||(null===E&&(d=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),E=!!d&&(536>parseInt(d[1],10)||536===parseInt(d[1],10)&&11>=parseInt(d[2],10))),d=E&&(k==y&&l==y&&m==y||k==z&&l==z&&m==z||k==A&&l==A&&m==A)),d=!d;d&&(null!==f.parentNode&&f.parentNode.removeChild(f),clearTimeout(e),K(b));}function t(){if((new Date).getTime()-J>=q)null!==f.parentNode&&f.parentNode.removeChild(f),
  L(Error(""+q+"ms timeout exceeded"));else{var d=b.context.document.hidden;if(!0===d||void 0===d)k=h.g.offsetWidth,l=n.g.offsetWidth,m=v.g.offsetWidth,r();e=setTimeout(t,50);}}var h=new w(g),n=new w(g),v=new w(g),k=-1,l=-1,m=-1,y=-1,z=-1,A=-1,f=document.createElement("div");f.dir="ltr";x(h,N(b,"sans-serif"));x(n,N(b,"serif"));x(v,N(b,"monospace"));f.appendChild(h.g);f.appendChild(n.g);f.appendChild(v.g);b.context.document.body.appendChild(f);y=h.g.offsetWidth;z=n.g.offsetWidth;A=v.g.offsetWidth;t();
  C(h,function(d){k=d;r();});x(h,N(b,'"'+b.family+'",sans-serif'));C(n,function(d){l=d;r();});x(n,N(b,'"'+b.family+'",serif'));C(v,function(d){m=d;r();});x(v,N(b,'"'+b.family+'",monospace'));});})};module.exports=D;}());
  });

  /*
   * This has a few utilities we need for the amount field.
   * If only the web supported what we need :-(
   */

  var removeChild = function () {
    var _document$body;

    return document && document.body && document.body.removeChild && (_document$body = document.body).removeChild.apply(_document$body, arguments);
  };

  var appendChild = function () {
    var _document$body2;

    return document && document.body && document.body.appendChild && (_document$body2 = document.body).appendChild.apply(_document$body2, arguments);
  };
  /**
   * A wrapper around the FontFaceObserver API because the FontFaceObserver is confusing and looks like it's going to do
   * the font loading based on the `load` function name, but it's just checking whether the font has loaded...
   * @param fontFamily - the font family to ensure is loaded
   * @param options - the options object passed to the FontFaceObserver constructor
   * @return a promise that resolves if the font loaded successfully, or rejects if it does not (default timeout is 3
   * seconds)
   */


  function isFontLoaded(fontFamily) {
    return new fontfaceobserver_standalone(fontFamily).load().catch(function (err) {
      // eslint-disable-next-line no-console
      console.warn("Could not load the font \"".concat(fontFamily, "\""));
      throw err;
    });
  }
  /**
   *  Takes the entered value in the amount field
   *  @param string - value entered in the amount field
   *  @returns number - removes any non digits character and only returns numeric entry.
   *  \s is for removing spaces which is part of currency format for certain countries (Norwegian Krone etc.)
   */


  function replaceNonDigits(value) {
    return value && value.replace(/[\.,٫\s]/g, '') || '';
  }
  /**
   * Use to format user input. Combines getCurrencyPrecision, replaceNonDigits, calcNewValue, and formatInput because that's
   * used several places.
   * 'USD', '.', '1' -> '0.01'
   * 'JPY', '.', '53' -> '53'
   * 'CAD', ',', '5323' -> '53,23'
   * @param currencyCode the currency code (to get the precision)
   * @param currencyDecimal the decimal separator
   * @param userInput the user input number to format
   * @return the formatted input
   */


  function formatUserCentsInput(currencyCode, currencyDecimal, userInput) {
    var currencyPrecision = getCurrencyPrecision(currencyCode);
    var digitsOnlyValue = replaceNonDigits(userInput);
    var zeroPaddedValue = calcNewValue(currencyPrecision, digitsOnlyValue);
    return formatInput(currencyPrecision, currencyDecimal, zeroPaddedValue);
  }
  /**
   * This function helps catch currencies with different float rules.
   * Generally we display 2 ints past the decimal (i.e $1.25).
   * @param currencyCode - The new currency currencyCode
   * @returns currencyPrecision
   */


  function getCurrencyPrecision(currencyCode) {
    return {
      JPY: true,
      TWD: true,
      HUF: true
    }[currencyCode] ? 0 : 2;
  }
  /**
   * Calculates the amount entered.
   * ex: user enters 1, value will return 0001
   * strips off leading zeroes (returning 1)
   * calculates the total number of zeroes required to be prepended
   * returns 001
   * @param currencyPrecision - returns number of digits and decimal separator i.e.  2 for USD, 0 for JPY
   * @param value - returns the entered value
   * @returns {*}
   */


  function calcNewValue(currencyPrecision, value) {
    var stringValue = value; // strips off leading zeroes

    stringValue = stringValue.replace(/^0+/, ''); // calculates number of zeroes required to be prepended based on value length

    stringValue = prependWithZeroes(currencyPrecision, stringValue);
    return stringValue;
  }
  /**
   * Formats the input given the raw string value.
   * ex: raw string value returns 001 -> formats to 0.01
   * 012 -> formats to 0.12
   * 123 -> formats to 1.23
   * 1234 -> formats to 1234
   * @param currencyPrecision - number of digits after decimal separator i.e. 2 for USD, 0 for JPY
   * @param currencyDecimal - decimal separator string i.e. '.' for USD, ',' for EURO
   * @param stringVal - unformatted string value entered
   * @returns formattedValue (12.34)
   */


  function formatInput(currencyPrecision, currencyDecimal, stringVal) {
    var formattedValue;
    var sliceDigitsBeforeCurrencyDecimal = '';
    var sliceDigitsAfterCurrencyDecimal = '';

    if (currencyPrecision > 0) {
      sliceDigitsBeforeCurrencyDecimal = stringVal.slice(0, stringVal.length - 2);
      sliceDigitsAfterCurrencyDecimal = stringVal.slice(stringVal.length - 2);
      formattedValue = "".concat(sliceDigitsBeforeCurrencyDecimal).concat(currencyDecimal).concat(sliceDigitsAfterCurrencyDecimal);
    } else {
      formattedValue = parseInt(stringVal, 10).toString();
    }

    return formattedValue;
  }
  /**
   * Prepends the input digit amount with zeroes ("1" => "001")
   * @param {number} currencyPrecision - returns number of digits and decimal separator i.e.  2 for USD, 0 for JPY
   * @param {string} amount entered value i.e 12
   * @returns {string} formatted value with total number of zeroes prepended
   */


  function prependWithZeroes(currencyPrecision, amount) {
    var numOfZeroesToAdd = Math.max(0, currencyPrecision + 1 - amount.length);
    return '0'.repeat(numOfZeroesToAdd) + amount;
  }

  /**
   * updates Font Size on mapping digits entered length
   * @param value - formatted entered input
   * @param currencySymbol - the currency Symbol i.e. '$' for USD
   * @returns {*|number}
   */
  function updateFontSize(_ref) {
    var value = _ref.value,
        currencySymbol = _ref.currencySymbol,
        fontSizeMapping = _ref.fontSizeMapping,
        defaultFontSize = _ref.defaultFontSize;

    if (!fontSizeMapping) {
      return defaultFontSize || null;
    }

    var digitCount = value.replace(/[.,]/g, '').length;
    var currencyCharCount = currencySymbol.length;
    var digitMapping = fontSizeMapping[String(currencyCharCount)] || {};
    return digitMapping[String(digitCount)] || defaultFontSize || null;
  }
  /**
   * Computes the required width size for amount field expansion
   */


  function measureTextSizeWithStyle(_ref2) {
    var fontSize = _ref2.fontSize,
        hostElement = _ref2.hostElement,
        text = _ref2.text;
    // get the computed styles from the element and grab the font-family and font-weight
    // for accurate measurements, with sensible defaults
    var hostElementStyles = hostElement ? window.getComputedStyle(hostElement, null) : {}; // handle `null` as well as `undefined`

    var spanElem = document.createElement('span');
    var _hostElementStyles$fo = hostElementStyles.fontWeight,
        fontWeight = _hostElementStyles$fo === void 0 ? '300' : _hostElementStyles$fo,
        fontFamily = hostElementStyles.fontFamily,
        paddingLeft = hostElementStyles.paddingLeft,
        paddingRight = hostElementStyles.paddingRight,
        borderWidth = hostElementStyles.borderWidth;
    fontSize = fontSize || hostElementStyles.fontSize;
    spanElem.style.fontSize = typeof fontSize === 'number' ? "".concat(fontSize, "px") : fontSize;
    spanElem.style.fontFamily = fontFamily;
    spanElem.style.fontWeight = fontWeight;
    spanElem.style.position = 'fixed';
    spanElem.style.top = '-1000px';
    spanElem.style.left = '-1000px';
    spanElem.innerHTML = text;
    appendChild(spanElem);
    var width = spanElem.clientWidth;
    removeChild(spanElem);
    return (width || 0) + cssMeasurementToNumber(paddingLeft) + cssMeasurementToNumber(paddingRight) + cssMeasurementToNumber(borderWidth) * 2;
  }

  function cssMeasurementToNumber() {
    var measurement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0px';
    return Number(measurement.replace(/[^0-9.]/g, ''));
  }
  /**
   * This moves the cursor position to the end of the text in the input node in a way
   * that works on iOS
   * @param {HTMLInputElement} node - the input to set the cursor position in
   */


  function moveCursorToTheEnd(node) {
    var length = node.value.length;
    node.setSelectionRange(length, length);
  }

  /**
   * This is intended to be used to call all given event handlers.
   * They are executed in order until one of them sets
   * `event.preventPPAmountFieldDefault = true`.
   * @param {Function} fns the event handler functions
   * @return {Function} the event handler to add to an element
   */
  function callAllEventHandlers() {
    for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    return function (event) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return fns.some(function (fn) {
        if (fn) {
          fn.apply(void 0, [event].concat(args));
        }

        return event.preventPPAmountFieldDefault;
      });
    };
  }
  /**
   * Function that returns a function which calls all given functions
   * with the given arguments arguments
   */


  function callAll() {
    for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      fns[_key3] = arguments[_key3];
    }

    return function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return fns.filter(Boolean).forEach(function (fn) {
        if (fn) {
          fn.apply(void 0, args);
        }
      });
    };
  }
  /* eslint flowtype/no-weak-types:0 */

  var _excluded = ["refKey", "ref", "style", "onChange", "onFocus", "onClick"],
      _excluded2 = ["ref", "refKey", "onChange", "style"];

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
  var MAX_AMOUNT_LENGTH = 10;

  var SingleAmountField = /*#__PURE__*/function (_Component) {
    _inherits(SingleAmountField, _Component);

    var _super = _createSuper(SingleAmountField);

    function SingleAmountField() {
      var _this;

      _classCallCheck(this, SingleAmountField);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

      _defineProperty(_assertThisInitialized(_this), "_input", null);

      _defineProperty(_assertThisInitialized(_this), "_select", null);

      _defineProperty(_assertThisInitialized(_this), "amountWidth", -1);

      _defineProperty(_assertThisInitialized(_this), "amountFontSize", -1);

      _defineProperty(_assertThisInitialized(_this), "currencyCodeWidth", -1);

      _defineProperty(_assertThisInitialized(_this), "formattedValue", void 0);

      _defineProperty(_assertThisInitialized(_this), "handleSelectChange", function (_ref) {
        var currencyCode = _ref.target.value;
        return _this.handleChange({
          currencyCode: currencyCode
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (_ref2) {
        var _ref2$target = _ref2.target;
        _ref2$target = _ref2$target === void 0 ? {} : _ref2$target;
        var _ref2$target$value = _ref2$target.value,
            value = _ref2$target$value === void 0 ? '' : _ref2$target$value;
        return _this.handleChange({
          value: value
        });
      });

      _defineProperty(_assertThisInitialized(_this), "moveCursor", function () {
        _this._input && moveCursorToTheEnd(_this._input);
      });

      _defineProperty(_assertThisInitialized(_this), "getInputProps", function () {
        var _objectSpread2;

        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var _props$refKey = props.refKey,
            refKey = _props$refKey === void 0 ? 'ref' : _props$refKey,
            ref = props.ref,
            style = props.style,
            onChange = props.onChange,
            onFocus = props.onFocus,
            onClick = props.onClick,
            rest = _objectWithoutProperties(props, _excluded);

        var inputStyles = {
          width: _this.amountWidth,
          fontSize: _this.amountFontSize
        };
        return _objectSpread(_objectSpread({
          value: _this.formattedValue,
          dir: 'ltr',
          autoComplete: 'off',
          type: 'tel',
          autoFocus: !rest.readOnly
        }, rest), {}, (_objectSpread2 = {
          style: _objectSpread(_objectSpread({}, inputStyles), style)
        }, _defineProperty(_objectSpread2, refKey, callAll(ref, _this.inputRef)), _defineProperty(_objectSpread2, "onChange", callAllEventHandlers(onChange, _this.handleInputChange)), _defineProperty(_objectSpread2, "onFocus", callAllEventHandlers(onFocus, _this.moveCursor)), _defineProperty(_objectSpread2, "onClick", callAllEventHandlers(onClick, _this.moveCursor)), _objectSpread2));
      });

      _defineProperty(_assertThisInitialized(_this), "inputRef", function (el) {
        return _this._input = el;
      });

      _defineProperty(_assertThisInitialized(_this), "getSelectProps", function () {
        var _objectSpread3;

        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var ref = props.ref,
            _props$refKey2 = props.refKey,
            refKey = _props$refKey2 === void 0 ? 'ref' : _props$refKey2,
            onChange = props.onChange,
            style = props.style,
            rest = _objectWithoutProperties(props, _excluded2);

        return _objectSpread(_objectSpread({
          value: _this.props.currencyCode
        }, rest), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, refKey, callAll(ref, _this.selectRef)), _defineProperty(_objectSpread3, "onChange", callAllEventHandlers(onChange, _this.handleSelectChange)), _defineProperty(_objectSpread3, "style", _objectSpread(_objectSpread({}, style), {}, {
          width: _this.currencyCodeWidth
        })), _objectSpread3));
      });

      _defineProperty(_assertThisInitialized(_this), "selectRef", function (el) {
        return _this._select = el;
      });

      return _this;
    }

    _createClass(SingleAmountField, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this._isMounted = true;
        isFontLoaded(window.getComputedStyle(this._input)['font-family'].split(',')[0].trim()).then(function () {
          // it could have unmounted before this is resolved
          if (_this2._isMounted) {
            // once the font has been confirmed to be loaded, we need to recalculate the width of the input.
            // but we do it in a setTimeout because otherwise sometimes the width calculation was off by 2px.
            // And I have no idea why...
            setTimeout(function () {
              _this2.forceUpdate();

              _this2.moveCursor();

              _this2.props.onFontLoaded && _this2.props.onFontLoaded();
            }, 50);
          }
        }).catch(function () {// do absolutely nothing
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._isMounted = false;
      }
      /**
       * This handles the value and currency change. Because a change in currency can cause a change in the value (due to
       * differences in precision), this will be called when the value or the currency is changed.
       *
       * We first strip out all non-digits then validate that the result is a real number. If it's not, then we don't do
       * anything (and the input value is not updated). If the result is equal to 0, then we'll call onAmountChange with an
       * empty string. Otherwise, we'll format it and if it's not the same as it was before, we'll call onAmountChange with
       * that.
       * @param {Object} changes holds the new value and the currencyCode
       */

    }, {
      key: "handleChange",
      value: function handleChange(_ref3) {
        var _ref3$value = _ref3.value,
            value = _ref3$value === void 0 ? this.props.value : _ref3$value,
            _ref3$currencyCode = _ref3.currencyCode,
            currencyCode = _ref3$currencyCode === void 0 ? this.props.currencyCode : _ref3$currencyCode;
        var cleanValue = replaceNonDigits(value); // convert value to number to remove leading zeros

        var numberValue = Number(cleanValue);

        if (_isNaN(numberValue) || cleanValue.length >= MAX_AMOUNT_LENGTH) {
          this.props.onInvalidInput();
          return;
        } else if (numberValue === 0) {
          this.props.onChange('', currencyCode);
          return;
        }

        var formattedValue = formatUserCentsInput(currencyCode, this.props.currencyDecimal, numberValue.toString());

        if (formattedValue !== this.props.value || currencyCode !== this.props.currencyCode) {
          this.props.onChange(formattedValue, currencyCode);
        }
      }
    }, {
      key: "getStateAndHelpers",
      value: function getStateAndHelpers() {
        return {
          amountWidth: this.amountWidth,
          currencyCodeWidth: this.currencyCodeWidth,
          amountFontSize: this.amountFontSize,
          getInputProps: this.getInputProps,
          getSelectProps: this.getSelectProps
        };
      }
    }, {
      key: "makeCalculations",
      value: function makeCalculations() {
        var _this$props = this.props,
            value = _this$props.value,
            currencyCode = _this$props.currencyCode,
            currencySymbolMap = _this$props.currencySymbolMap,
            fontSizeMapping = _this$props.fontSizeMapping,
            defaultFontSize = _this$props.defaultFontSize;
        var currencySymbol = currencySymbolMap[currencyCode];
        this.formattedValue = this.props.getFormattedValue(value || '0');
        this.amountFontSize = updateFontSize({
          value: this.formattedValue,
          currencySymbol: currencySymbol,
          fontSizeMapping: fontSizeMapping,
          defaultFontSize: defaultFontSize
        });
        this.amountWidth = measureTextSizeWithStyle({
          fontSize: this.amountFontSize,
          hostElement: this._input,
          text: this.formattedValue
        }) + 2; // sadly, firefox and IE both insert a few pixels to the left (or right in
        // the rtl case) of select inputs. This behavior is totally unobservable
        // (so it cannot be part of the width calculation).
        // So we'll add a few pixels to the width in IE and firefox to account
        // for this (as select is the main use case for this anyway).

        var ua = navigator.userAgent.toLowerCase();
        var isFirefox = ua.includes('firefox');
        var isIE11 = ua.includes('Trident/7') || !!window.MSInputMethodContext && !!document.documentMode;
        var isIE = ua.includes('msie') || isIE11;
        var extraSpaceToAccountForWeirdBrowserIssues = isFirefox || isIE ? 6 : 0;
        this.currencyCodeWidth = measureTextSizeWithStyle({
          fontSize: null,
          hostElement: this._select,
          text: currencyCode
        }) + extraSpaceToAccountForWeirdBrowserIssues;
      }
    }, {
      key: "render",
      value: function render() {
        this.makeCalculations();
        return this.props.children(this.getStateAndHelpers());
      }
    }]);

    return SingleAmountField;
  }(React.Component);
  /* eslint no-unused-expressions:0 */

  var _jsxFileName = "/Users/sdeepala/projects/pp-amount-field/src/basic/index.js";
  var _excluded$1 = ["showCondensedUI", "renderAfterInput", "arrowProps", "className", "inputProps", "selectProps", "fontFamily"];

  function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

  function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

  function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

  var BasicAmountField = /*#__PURE__*/function (_React$Component) {
    _inherits(BasicAmountField, _React$Component);

    var _super = _createSuper$1(BasicAmountField);

    function BasicAmountField() {
      var _this;

      _classCallCheck(this, BasicAmountField);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "renderTimeoutId", void 0);

      _defineProperty(_assertThisInitialized(_this), "state", {
        showInvalid: false,
        hideCursor: false,
        visible: false
      });

      _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function () {
        return _this.setState({
          hideCursor: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function () {
        return _this.setState({
          hideCursor: false
        });
      });

      _defineProperty(_assertThisInitialized(_this), "showInvalid", function () {
        _this.setState({
          showInvalid: true
        }, function () {
          setTimeout(function () {
            _this.setState({
              showInvalid: false
            });
          }, 300);
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handleFontLoaded", function () {
        // we wait for the font to load and widths to be calculated before showing the input
        // otherwise we run into a flash of unstyled content on refresh.
        // In componentDidMount we have a timeout to ensure that we don't wait any longer than 500ms
        clearTimeout(_this.renderTimeoutId);

        _this.setState({
          visible: true
        });
      });

      return _this;
    }

    _createClass(BasicAmountField, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // this ensures that we don't wait any longer than a half a second to display the input
        this.renderTimeoutId = setTimeout(function () {
          this.setState({
            visible: true
          });
        }, 500);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (this.props.showInvalid) {
          this.showInvalid();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$props = this.props,
            _this$props$showConde = _this$props.showCondensedUI,
            showCondensedUI = _this$props$showConde === void 0 ? false : _this$props$showConde,
            _this$props$renderAft = _this$props.renderAfterInput,
            renderAfterInput = _this$props$renderAft === void 0 ? function () {
          return null;
        } : _this$props$renderAft,
            _this$props$arrowProp = _this$props.arrowProps,
            arrowProps = _this$props$arrowProp === void 0 ? {} : _this$props$arrowProp,
            _this$props$className = _this$props.className,
            className = _this$props$className === void 0 ? '' : _this$props$className,
            _this$props$inputProp = _this$props.inputProps,
            inputProps = _this$props$inputProp === void 0 ? {} : _this$props$inputProp,
            _this$props$selectPro = _this$props.selectProps,
            selectProps = _this$props$selectPro === void 0 ? {} : _this$props$selectPro,
            fontFamily = _this$props.fontFamily,
            forwardToAmountField = _objectWithoutProperties(_this$props, _excluded$1);

        var _this$state = this.state,
            showInvalid = _this$state.showInvalid,
            visible = _this$state.visible,
            hideCursor = _this$state.hideCursor; // stuff we forward on, but also want to reference in this function

        var currencySymbolMap = forwardToAmountField.currencySymbolMap,
            currencyCode = forwardToAmountField.currencyCode;
        var currencyCodeList = [];

        if (this.props.currencyCodeList && this.props.currencyCodeList.length) {
          currencyCodeList = this.props.currencyCodeList;
        } else {
          currencyCodeList = Object.keys(currencySymbolMap);
        }

        return /*#__PURE__*/React__default.createElement(SingleAmountField, _extends({}, forwardToAmountField, {
          onFontLoaded: this.handleFontLoaded,
          onInvalidInput: callAll(this.props.onInvalidInput, this.showInvalid),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103,
            columnNumber: 7
          }
        }), function (_ref) {
          var currencyCodeWidth = _ref.currencyCodeWidth,
              getSelectProps = _ref.getSelectProps,
              getInputProps = _ref.getInputProps;
          var currencySymbol = currencySymbolMap[currencyCode];
          var inputWrapperClasses = classnames('ppaf-input-wrapper', {
            'ppaf-shake': showInvalid
          });
          var currencySymbolClassNames = classnames('ppaf-currency-symbol', showInvalid && 'ppaf-is-invalid');
          var inputClassNames = classnames('ppaf-input', hideCursor && 'ppaf-with-hidden-cursor', inputProps.readOnly && 'ppaf-read-only', // overrides cursor to default
          showInvalid && 'ppaf-is-invalid');
          var dropdownWrapperClassNames = classnames('ppaf-select-wrapper', showCondensedUI && 'ppaf-condensed', selectProps.disabled && 'ppaf-read-only' // overrides color to input default (black)
          );
          var dropdownClassNames = classnames('ppaf-select', selectProps.disabled && 'ppaf-read-only' // overrides cursor to default
          );
          return /*#__PURE__*/React__default.createElement("div", {
            className: "pp-amount-field ".concat(className || ''),
            style: {
              visibility: visible ? 'visible' : 'hidden'
            },
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 139,
              columnNumber: 13
            }
          }, /*#__PURE__*/React__default.createElement("div", {
            className: inputWrapperClasses,
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 143,
              columnNumber: 15
            }
          }, /*#__PURE__*/React__default.createElement("div", {
            className: currencySymbolClassNames,
            style: {
              color: inputProps.style ? inputProps.style.color : null,
              fontFamily: fontFamily
            },
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 144,
              columnNumber: 17
            }
          }, currencySymbol), /*#__PURE__*/React__default.createElement("input", _extends({}, getInputProps(_objectSpread$1(_objectSpread$1({
            name: 'amount',
            required: true,
            className: inputClassNames
          }, inputProps), {}, {
            style: _objectSpread$1({
              fontFamily: fontFamily
            }, inputProps.style),
            onMouseDown: callAllEventHandlers(inputProps.onMouseDown, _this3.handleMouseDown),
            onMouseUp: callAllEventHandlers(inputProps.onMouseUp, _this3.handleMouseUp)
          })), {
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 153,
              columnNumber: 17
            }
          })), renderAfterInput(_this3.props)), currencyCodeList.length ? /*#__PURE__*/React__default.createElement("div", {
            className: dropdownWrapperClassNames,
            style: {
              width: currencyCodeWidth,
              color: selectProps.style ? selectProps.style.color : null
            },
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 176,
              columnNumber: 17
            }
          }, /*#__PURE__*/React__default.createElement("select", _extends({}, getSelectProps(_objectSpread$1(_objectSpread$1({
            name: 'currencies',
            className: dropdownClassNames
          }, selectProps), {}, {
            style: _objectSpread$1({
              fontFamily: fontFamily
            }, selectProps.style)
          })), {
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 183,
              columnNumber: 19
            }
          }), currencyCodeList.map(function (code) {
            return /*#__PURE__*/React__default.createElement("option", {
              key: code,
              value: code,
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 195,
                columnNumber: 23
              }
            }, code);
          })), !selectProps.disabled && /*#__PURE__*/React__default.createElement(ArrowIcon, _extends({}, arrowProps, {
            style: _objectSpread$1({
              left: (currencyCodeWidth || 0) - 20
            }, arrowProps.style),
            __self: _this3,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 202,
              columnNumber: 21
            }
          }))) : null);
        });
      }
    }]);

    return BasicAmountField;
  }(React__default.Component);

  function ArrowIcon(props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      className: "ppaf-select-arrow",
      viewBox: "0 0 20 20",
      preserveAspectRatio: "none",
      width: 14,
      height: 16,
      fill: "transparent",
      stroke: "currentColor",
      strokeWidth: "2px"
    }, props, {
      style: _objectSpread$1({
        paddingBottom: 2
      }, props.style),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 222,
        columnNumber: 5
      }
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M1,6 L10,15 L19,6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 234,
        columnNumber: 7
      }
    }));
  }

  var _jsxFileName$1 = "/Users/sdeepala/projects/pp-amount-field/src/basic/amount-field-with-css.js";

  function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

  function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

  var AmountFieldWithCSS = /*#__PURE__*/function (_React$Component) {
    _inherits(AmountFieldWithCSS, _React$Component);

    var _super = _createSuper$2(AmountFieldWithCSS);

    function AmountFieldWithCSS() {
      _classCallCheck(this, AmountFieldWithCSS);

      return _super.apply(this, arguments);
    }

    _createClass(AmountFieldWithCSS, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props = this.props,
            version = _this$props.version,
            stylesString = _this$props.stylesString;
        var stylesId = "amount-field-basic-v".concat(version);

        if (document.head && !document.head.querySelector("#".concat(stylesId))) {
          var styles = document.createElement('style');
          styles.id = stylesId;
          styles.append(stylesString);
          document.head && document.head.appendChild(styles);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React__default.createElement(BasicAmountField, _extends({
          className: "basic-v".concat(this.props.version)
        }, this.props, {
          __self: this,
          __source: {
            fileName: _jsxFileName$1,
            lineNumber: 31,
            columnNumber: 7
          }
        }));
      }
    }]);

    return AmountFieldWithCSS;
  }(React__default.Component);
  /* eslint no-unused-expressions:0 */

  var _jsxFileName$2 = "/Users/sdeepala/projects/pp-amount-field/src/basic/v2.js";
  var stylesString = ".pp-amount-field .ppaf-input-wrapper{display:flex;justify-content:center}[dir=ltr] .pp-amount-field .ppaf-input-wrapper.ppaf-shake{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-name:ppaf-shake-ltr;animation-name:ppaf-shake-ltr}[dir=rtl] .pp-amount-field .ppaf-input-wrapper.ppaf-shake{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-name:ppaf-shake-rtl;animation-name:ppaf-shake-rtl}@-webkit-keyframes ppaf-shake-ltr{from,to{transform:translate3d(0,0,0)}10%,30%,50%,70%,90%{transform:translate3d(-10px,0,0)}20%,40%,60%,80%{transform:translate3d(10px,0,0)}}@keyframes ppaf-shake-ltr{from,to{transform:translate3d(0,0,0)}10%,30%,50%,70%,90%{transform:translate3d(-10px,0,0)}20%,40%,60%,80%{transform:translate3d(10px,0,0)}}@-webkit-keyframes ppaf-shake-rtl{from,to{transform:translate3d(0,0,0)}10%,30%,50%,70%,90%{transform:translate3d(10px,0,0)}20%,40%,60%,80%{transform:translate3d(-10px,0,0)}}@keyframes ppaf-shake-rtl{from,to{transform:translate3d(0,0,0)}10%,30%,50%,70%,90%{transform:translate3d(10px,0,0)}20%,40%,60%,80%{transform:translate3d(-10px,0,0)}}.pp-amount-field .ppaf-currency-symbol{color:#2c2e2f;font-weight:300;font-family:PayPal-Sans-Big,sans-serif;display:inline-block;vertical-align:top}[dir=ltr] .pp-amount-field .ppaf-currency-symbol{text-align:right}[dir=rtl] .pp-amount-field .ppaf-currency-symbol{text-align:left}.pp-amount-field .ppaf-input{color:#2c2e2f;text-overflow:clip;outline:0;letter-spacing:normal;line-height:1.4;font-weight:300;text-transform:none;font-family:PayPal-Sans-Big,sans-serif}[dir] .pp-amount-field .ppaf-input{background:0 0;border:none;text-align:center;padding:0;margin:0;cursor:pointer}.pp-amount-field .ppaf-input.ppaf-with-hidden-cursor{color:transparent}[dir] .pp-amount-field .ppaf-input.ppaf-with-hidden-cursor{text-shadow:#2c2e2f 0 0 0}[dir] .pp-amount-field .ppaf-input.ppaf-read-only{cursor:default}.pp-amount-field .ppaf-select-wrapper{position:relative}[dir=ltr] .pp-amount-field .ppaf-select-wrapper{margin-left:auto;margin-right:auto}[dir=rtl] .pp-amount-field .ppaf-select-wrapper{margin-right:auto;margin-left:auto}[dir] .pp-amount-field .ppaf-select-wrapper.ppaf-condensed{margin-top:0;margin-bottom:0}.pp-amount-field .ppaf-select{font-size:20px;position:absolute;appearance:none;-webkit-appearance:none;-moz-appearance:none;padding-top:4px;font-weight:700;padding-right:20px;padding-bottom:4px;padding-left:2px;background-color:transparent;color:inherit;top:0;left:-2px;z-index:2;cursor:pointer;font-family:PayPal-Sans-Big,sans-serif}.pp-amount-field .ppaf-select::-ms-expand{display:none}[dir] .pp-amount-field .ppaf-select.ppaf-read-only{cursor:default}.pp-amount-field .ppaf-select-arrow{position:absolute;z-index:1}.pp-amount-field .ppaf-first-time-user-tooltip-wrapper{line-height:77px}.pp-amount-field .ppaf-tooltip{font-size:24px;position:relative;color:#0070ba}[dir] .pp-amount-field .ppaf-tooltip{cursor:pointer}[dir=ltr] .pp-amount-field .ppaf-tooltip{margin-left:5px}[dir=rtl] .pp-amount-field .ppaf-tooltip{margin-right:5px}.pp-amount-field .ppaf-is-invalid{color:#d20000}" + '\n' + "[dir] .pp-amount-field.basic-v2 .ppaf-currency-symbol{margin-top:12px}[dir=ltr] .pp-amount-field.basic-v2 .ppaf-currency-symbol{margin-right:6px}[dir=rtl] .pp-amount-field.basic-v2 .ppaf-currency-symbol{margin-left:6px}.pp-amount-field.basic-v2 .ppaf-select-wrapper{color:#0070ba;height:28px}[dir] .pp-amount-field.basic-v2 .ppaf-select-wrapper{margin-top:19px}.pp-amount-field.basic-v2 .ppaf-select{border:solid 1px;border-radius:18px;font-size:14px;padding-left:8px}.pp-amount-field.basic-v2 .ppaf-select-arrow{top:10px}";
  var defaultFontSize = 42;
  var fontSizeMapping = {
    '0': {
      '8': 40
    },
    '1': {
      '7': 38,
      '8': 36,
      '9': 32,
      '10': 30
    },
    '2': {
      '7': 38,
      '8': 36,
      '9': 32,
      '10': 28
    },
    '3': {
      '6': 36,
      '7': 32,
      '8': 28,
      '9': 26,
      '10': 24
    },
    '4': {
      '6': 36,
      '7': 32,
      '8': 28,
      '9': 26,
      '10': 24
    }
  };

  function V1AmountField(props) {
    return /*#__PURE__*/React__default.createElement(AmountFieldWithCSS, _extends({
      version: "2",
      stylesString: stylesString,
      fontSizeMapping: fontSizeMapping,
      defaultFontSize: defaultFontSize,
      arrowProps: {
        height: 11,
        width: 10
      },
      fontFamily: "'PayPal-Sans-Big', sans-serif"
    }, props, {
      __self: this,
      __source: {
        fileName: _jsxFileName$2,
        lineNumber: 25,
        columnNumber: 5
      }
    }));
  }

  exports.default = V1AmountField;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=pp-amount-field.basic.v2.umd.js.map
